import React from "react";
import classnames from "classnames";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import img from "assets/img/icons/dashboard2.jpg";

function Register() {
  const [focusedName, setFocusedName] = React.useState(false);
  const [focusedEmail, setFocusedEmail] = React.useState(false);
  const [focusedPassword, setFocusedPassword] = React.useState(false);

  return (
    <div className="login-page">
      {/* BACKGROUND IMAGE */}
      <div
        className="login-bg-image"
        style={{ backgroundImage: `url(${img})` }}
      />

      {/* GRADIENT OVERLAY */}
      <div className="login-bg-overlay" />

      {/* CONTENT */}
      <Container fluid className="login-content">
        <Row className="min-vh-100 align-items-center">
          {/* LEFT SIDE — BRANDING */}
          <Col lg="6" className="d-none d-lg-flex align-items-center">
            <div className="login-brand">
              <h1 className="text-white mb-3 display-2 font-weight-bold">
                Create an account
              </h1>
              <p className="text-light lead">Let’s get started</p>
            </div>
          </Col>

          {/* RIGHT SIDE — REGISTER */}
          <Col
            lg="6"
            md="6"
            className="d-flex justify-content-center align-items-center"
          >
            <div className="login-card-wrapper">
              {/* MOBILE HEADER */}
              <div className="d-block d-lg-none text-center mb-4">
                <h2 className="text-white font-weight-bold mb-1">
                  Create an account
                </h2>
                <p className="text-light small opacity-75">Let’s get started</p>
              </div>

              <Card className="border-0 shadow-lg rounded-lg">
                <CardBody className="login-card-body">
                  <div className="text-center mb-4">
                    <h2 className="font-weight-bold mb-1">Sign Up</h2>
                    <p className="text-muted mb-0">Sign up with</p>
                  </div>

                  {/* SOCIAL SIGNUP */}
                  <div className="d-flex justify-content-center mb-4">
                    <Button
                      className="btn-icon btn-neutral rounded-circle shadow-sm mr-3"
                      color="default"
                    >
                      <img
                        alt="Github"
                        src={
                          require("assets/img/icons/common/github.svg").default
                        }
                        width="24"
                      />
                    </Button>
                    <Button
                      className="btn-icon btn-neutral rounded-circle shadow-sm"
                      color="default"
                    >
                      <img
                        alt="Google"
                        src={
                          require("assets/img/icons/common/google.svg").default
                        }
                        width="24"
                      />
                    </Button>
                  </div>

                  <div className="text-center text-muted mb-4">
                    <small>or sign up with credentials</small>
                  </div>

                  <Form role="form">
                    {/* NAME */}
                    <FormGroup
                      className={classnames("mb-3", {
                        focused: focusedName,
                      })}
                    >
                      <InputGroup className="input-group-merge">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-hat-3" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Full Name"
                          bsSize="lg"
                          onFocus={() => setFocusedName(true)}
                          onBlur={() => setFocusedName(false)}
                        />
                      </InputGroup>
                    </FormGroup>

                    {/* EMAIL */}
                    <FormGroup
                      className={classnames("mb-3", {
                        focused: focusedEmail,
                      })}
                    >
                      <InputGroup className="input-group-merge">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="email"
                          placeholder="Email"
                          bsSize="lg"
                          onFocus={() => setFocusedEmail(true)}
                          onBlur={() => setFocusedEmail(false)}
                        />
                      </InputGroup>
                    </FormGroup>

                    {/* PASSWORD */}
                    <FormGroup
                      className={classnames("mb-3", {
                        focused: focusedPassword,
                      })}
                    >
                      <InputGroup className="input-group-merge">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-lock-circle-open" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password"
                          bsSize="lg"
                          onFocus={() => setFocusedPassword(true)}
                          onBlur={() => setFocusedPassword(false)}
                        />
                      </InputGroup>
                    </FormGroup>

                    {/* TERMS */}
                    <div className="custom-control custom-checkbox mb-4">
                      <input
                        className="custom-control-input"
                        id="termsCheck"
                        type="checkbox"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="termsCheck"
                      >
                        I agree to the{" "}
                        <a href="#!" className="text-primary">
                          Privacy Policy
                        </a>
                      </label>
                    </div>

                    <Button block color="primary" size="lg">
                      Create Account
                    </Button>
                  </Form>

                  {/* FOOTER */}
                  <div className="mt-4 text-center">
                    <small className="text-muted">
                      Already have an account?{" "}
                      <a
                        href="/auth/login"
                        className="text-primary font-weight-bold"
                      >
                        Sign in
                      </a>
                    </small>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Register;
